<template>
  <div>
    <v-data-table
        dense
        :headers="columns"
        :items="getProviderList"
        item-key="id"
        class="elevation-1"
        :sort-by="['name']"
        :height="windowHeight"
        :loading="getBrandProviderListLoader"
        show-expand
        :expanded="getBrandProviderListExpand"
        :options="getBrandProviderListOptions"
        hide-default-footer
        fixed-header
    >
      <template v-slot:item.is_unbroken="{ item }">
        <BaseBoolIndicator v-bind:value=item.is_unbroken></BaseBoolIndicator>
      </template>

      <template v-slot:item.are_comparable="{ item }">
        <BaseBoolIndicator v-bind:value=item.are_comparable></BaseBoolIndicator>
      </template>

      <template v-slot:item.name="{ item }">
          <span>
              <router-link :to="{name:'BrandProviderItem', params: { brandProviderId: item.id}}">
                {{ item.name }}
              </router-link>
          </span>
      </template>

      <template v-slot:item.last_successful_check="{ item }">
        {{ item.last_successful_check | moment("YY.MM.DD HH:mm") }}
      </template>

      <template v-slot:item.scrap_enable="{ item }">
          <span>
            <v-checkbox
                class="mt-3 mb-n3"
                v-model="item.scrap_enable"
                dense
                outlined
            ></v-checkbox>
          </span>
      </template>
      <template v-slot:item.lead_day="{ item }">
          <span>
            <v-text-field
                class="mt-3 mb-n3"
                v-model="item.lead_day"
                dense
                outlined
            ></v-text-field>
          </span>
      </template>
      <template v-slot:item.cache_hours="{ item }">
          <span>
            <v-text-field
                class="mt-3 mb-n3"
                v-model="item.cache_hours"
                dense
                outlined
            ></v-text-field>
          </span>
      </template>
      <template v-slot:item.priority="{ item }">
          <span>
            <v-text-field
                class="mt-3 mb-n3"
                v-model="item.priority"
                dense
                outlined
            ></v-text-field>
          </span>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length" class="py-5 pl-16">
          <BrandProviderCheckList :brandProviderId="item.id"></BrandProviderCheckList>
        </td>
      </template>
    </v-data-table>
    <v-toolbar flat dense>
      <v-btn
          color="primary"
          @click="actionCheckProviders"
          class="mr-4"
          :loading="getBrandProviderActionCheckLoader"
      >
        Check providers
      </v-btn>
      <v-spacer></v-spacer>
      <BaseConformSave class="mr-4" :on-save-external="submit" color="primary"
                       :loading="getBrandProviderListLoader">
      </BaseConformSave>
      <v-btn class="mr-4" :to="{name: 'Home'}">
        Cancel
      </v-btn>
    </v-toolbar>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';
import BrandProviderItem from "@/components/Brand/BrandProviderItem";
import BrandProviderCheckList from "@/components/Brand/BrandProviderCheckList";

export default {
  name: 'BrandProviderList',

  components: {
    BrandProviderItem,
    BrandProviderCheckList,
  },

  computed: mapGetters(['getProviderList', 'getBrandProviderListLoader', 'getBrandProviderActionCheckLoader',
    'getBrandProviderListExpand', 'getBrandProviderListOptions']),

  methods: {
    ...mapActions(['fetchBrandProviderList', 'saveBrandProviderList', 'fetchActionCheckProviders']),
    actionCheckProviders() {
      this.fetchActionCheckProviders()
    },
    submit() {
      console.log('on-save-external')
      this.saving = true
      console.log(this.$root.$store.state.BrandProviderList.providerList)
      console.log(this.$root.$store.state.BrandProviderList.loadedProviderList)
      this.saveBrandProviderList()
      this.saving = false
    },
    cancel() {
      this.ignoreFlag = !this.ignoreFlag
      // this.fetchBrandComponentItem(this.$route.params.brandComponentId)
    },
    validate() {
      this.$refs.form.validate()
    },
    onResize() {
      this.windowHeight = (window.innerHeight - 130) + "px"
      this.windowWidth = (window.innerWidth) + "px"
      console.log('windowHeight')
      console.log(this.windowHeight)
    },
  },

  async mounted() {
    window.addEventListener("resize", this.onResize)
    await this.fetchBrandProviderList();
  },

  created() {
    window.addEventListener("resize", this.onResize);
  },

  destroyed() {
    window.removeEventListener("resize", this.onResize);
  },

  data() {
    return {
      columns: [
        // {text: 'Unbroken', value: 'is_unbroken', sortable: false, filterable: false, class: 'primary', divider: true},
        {text: 'Unbroken', value: 'is_unbroken', sortable: false, filterable: false, divider: true},
        {text: 'Comparable', value: 'are_comparable', sortable: false, filterable: false, divider: true},
        {text: 'Name', value: 'name', sortable: true, filterable: true, divider: true},
        {text: 'Last successful check', value: 'last_successful_check', sortable: true, filterable: true, divider: true},
        // {text: 'Brief name', value: 'brief_name', sortable: false,},
        // {text: 'Address', value: 'address', sortable: false,},
        // {text: 'Phone', value: 'phone', sortable: false,},
        {text: 'URL', value: 'url', sortable: false, divider: true},
        {text: 'Lead day', value: 'lead_day', sortable: false, divider: true},
        // {text: 'Notes', value: 'notes', sortable: false,},
        {text: 'Cache hours', value: 'cache_hours', sortable: false, divider: true},
        {text: 'Priority', value: 'priority', sortable: false, divider: true},
        {text: 'Search enable', value: 'scrap_enable', sortable: false, divider: true},
      ],
      windowHeight: (window.innerHeight - 130) + 'px',
      windowWidth: window.innerWidth + "px",
    }
  }
}
</script>

<style scoped lang="scss">
</style>
